module.exports = __webpack_public_path__ + "de2c825c16b63a16a1683c66e481a1cc.svg";